import { Mottagningsplats } from "~app/common/models/lagerplats/MottagningsplatsListResponseDTO";

export class SearchMottagningsplatsResultViewmodel {

    constructor(private readonly raw: Mottagningsplats) {

    }

    get id() {
        return this.raw.id;
    }

    get namn() {
        return this.raw.namn;
    }

    get aktiv() {
        return this.raw.aktiv;
    }

    get mottagningsplatsnummer() {
        return this.raw.mottagningsplatsnummer;
    }

    get mottagningsplatstyp() {
        return this.raw.mottagningsplatstyp;
    }

    get ansvarigLogistiker() {
        if (!this.raw.ansvarigLogistiker) {
            return null;
        }
        return this.raw.ansvarigLogistiker.name;
    }

    get beskrivning() {
        return this.raw.beskrivning;
    }

    get landskod() {
        return this.raw.land?.kod;
    }
}
